import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { Button } from 'reactstrap';
import { ChatContainer, MessageList, Message, MessageInput, TypingIndicator, ConversationHeader, Avatar } from '@chatscope/chat-ui-kit-react';

import styled from '@emotion/styled';

import ElementIcon from '../ElementIcon';

import FormattedMessage from './FormattedMessage';
import AIChatModal from './AIChatModal';
import useAIChat from './useAIChat';
import { keyframes } from '@emotion/react';

function AIChatFAV(props) {
  const {
    agent,
    agentTyping,
    agentError,
    messages,
    sendMessage,
    isOpen,
    toggleOpenChat,
    closeChat,
    chatContext,
    clearChat
  } = useAIChat(props);

  return (
    <Container>
      {isOpen ? (
        <AIChatModal
          agent={agent}
          messages={messages}
          chatContext={chatContext}
          agentTyping={agentTyping}
          agentError={agentError}
          open={isOpen}
          onSend={sendMessage}
          onClear={clearChat}
          onClose={closeChat}
        />
      ) : (
        <FAV
          color="primary"
          className={isOpen ? 'is-open' : 'is-closed'}
          onClick={toggleOpenChat}
          title={`${isOpen ? 'Close' : 'Open'} ${agent.name ?? ''}`}
        >
          <ElementIcon element={agent.icon} />
        </FAV>
      )}
    </Container>
  );
}

const Container = styled('div')({
  position: 'fixed',
  top: '100vh',
  left: '100vw',
  transform: 'translate(-5px, -5px)',
  zIndex: '900000',
});

const FAV = styled(Button)({
  margin: '0',
  top: 'auto',
  right: '20px',
  bottom: '20px',
  left: 'auto',
  position: 'fixed',
  borderRadius: '50% !important',
  width: '56px',
  height: '56px',
  padding: '0',
  zIndex: '900010',
  fontSize: '1.35em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#15416F',
  boxShadow: '0 3px 5px rgba(0, 0, 0, 0.3)',
  transform: 'scale(0.75) translate(15px, 15px)',
  transition: 'transform 1s, boxShadow 1s',
  '&:hover': {
    transform: 'scale(1) translate(0, 0)',
    background: '#15416F',
    boxShadow: ' 0px 5px 10px rgba(0, 0, 0, 0.25), 0px 15px 25px rgba(0, 0, 0, 0.2)',
  },
  '&.is-open': {
    // "display": "none"
  },
});

export default AIChatFAV;
